export default {
  title: 'Contact Information',
  edit: 'Edit Contact Information',
  success: 'Contact information was successfully saved'
}
